<div class="loading-spinner" [style.min-height]="minHeight" [class.fullscreen]="fullscreen">
	<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="42px" height="42px" viewBox="0 0 128 128" xml:space="preserve">
		<g transform="rotate(329.798 64.0001 64.0001)">
			<path class="spinner" [class]="color" d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z"></path>
			<animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="500ms" repeatCount="indefinite"></animateTransform>
		</g>
	</svg>
	<span *ngIf="showLabel" class="loading-text" [style.color]="color">{{ "loading" | translate }}...</span>
</div>
